<button mat-button color="primary" disableRipple="true" [matMenuTriggerFor]="langMenu">
  {{ activeLang$ | async | uppercase }}
</button>
<mat-menu #langMenu="matMenu">
  @for (lang of availableLangs; track lang) {
    <button mat-menu-item (click)="langChanged(lang)">{{ lang | uppercase }}</button>
  }
</mat-menu>
